import React, { ChangeEvent, FormEvent, useCallback, useContext, useMemo, useState } from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { BsImage } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import RegisterOscContext from '../../../context/RegisterContext'
import useApi from '../../../hooks/useApi'
import { Button } from '../../../Korbantech/components/Buttons/Button'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import TextareaInput from '../../../Korbantech/components/Inputs/TextareaInput'
import Modal from '../../../Korbantech/components/Modal'
import { Osc } from '../../../types/Osc'
import { LoginAlert } from '../../Alerts/LoginAlert'
import { SuccessAlert } from '../../Alerts/SuccessAlert'
import { SpinnerLoad } from '../../Loading/SpinnerLoad'
import { AceptTerms } from '../OscInputs/AceptTerms'
import { LogoChange } from '../OscInputs/LogoChange'




export const LogoAndDescription = ({ oldData, update, isPublic }: Props) => {


    const [file, setFile] = useState<string | undefined>(oldData?.logo)
    const [fileName, setFileName] = useState<string>("")
    const [newData, setNewData] = useState<Osc | undefined>(undefined)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [load, setLoad] = useState<boolean>(false)
    const [modal,setModal] = useState<boolean>(false)
    const [alert,] = useState<{type:number,header:string,message:string}| undefined>(undefined);

    const { setStep } = useContext(RegisterOscContext)
    const { osc } = useContext(RegisterOscContext)

    const api = useApi();
    const navigate = useNavigate();

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()
        setLoad(true)
        if (!e.currentTarget) return

        const data = new FormData(e.currentTarget)

        if (update && osc) {
            setLoad(true)
            data.append('_method', 'PATCH')
            if (isPublic){
                await api.post(`/client/me/description`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }else {
                await api.post(`admin/osc/${osc.id}/description`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }
            setLoad(false)
            return
        }

        if (!osc) return
        await api.post(`/osc/${osc.id}/end`, data).then(res => {
                setModal(true)
        }).catch(console.log)
        setLoad(false)

    }, [api, osc, update, isPublic])

    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {

        const files = e.currentTarget?.files
        if (files)
            setFileName(files[0].name)
        files && files[0] && (() => {
            const reader = new FileReader()
            reader.readAsDataURL(files[0])
            reader.onloadend = () => {
                setFile(reader.result?.toString())
            }
        })()
    }, [])

    const data = useMemo((): Osc | undefined => {

        let data: Osc | undefined = undefined

        if (osc) data = osc

        if (oldData) data = oldData

        if (newData) data = newData

        return data

    }, [oldData, osc, newData])

    return (
        <>
            <Modal open={modal} onClickOutside={()=>navigate("/osc/login")}>
                <div className='flex flex-col items-center p-2'>
                Cadastro finalizado
                 <AiOutlineCheckCircle className='text-4xl text-primary my-2'/>
                Seu cadastro foi enviado para análise
                 <Button value="Continuar" className="mt-3"
                 onClick={()=>navigate("/osc/login")}
                 />
                </div>
            </Modal>
            {update && <div className='font-semibold text-xl mb-2'>Contato</div>}
            {isSuccess && <SuccessAlert message='Dados Alterados' closeAlert={() => setIsSuccess(false)} />}
            <form onSubmit={handleSubmit} className={`grid gap-x-6 gap-y-4 grid-cols-1 md:grid-cols-8 text-gray-800 ${data && 'border-l-4 border-green-600 pl-4 pr-4 rounded-lg'}`}>
                {alert &&
                    <LoginAlert error={alert?.type === 2 && true}  header={alert?.header} text={alert.message}/>
                }
                    <div className='col-span-5'>
                        <LogoChange fileName={fileName} name='logo' onChange={handleChange} />
                        <div className='mt-2'>
                            <label>Descrição da OSC</label>
                            <TextareaInput className={'rounded-md h-48'} name={"description"} required rows='7' defaultValue={data?.description && data.description} />
                            <div className='text-sm italic'>
                                Descreva em até
                                800 caracteres a história da OSC e suas atividades
                            </div>
                        </div>
                    </div>
                    <div className='col-span-3'>
                        {file ? <img src={file} alt='logo' /> :
                            <div className='flex items-center justify-center bg-gray-100 h-36'>
                                <BsImage className='text-3xl text-gray-600' />
                            </div>

                        }
                    </div>

                    <div className='col-span-8'>
                        {!update && <AceptTerms />}
                    </div>

                    <div className='flex justify-between mb-3 mt-3 w-full col-span-8'>
                    {!load && <>
                        <div>
                            {!update && <button onClick={() => setStep(4)} className='border border-gray-500 bg-white py-1 px-2 rounded-md'>Anterior</button>}
                        </div>

                        <div>
                            <SubmitButton value={update ? "Atualizar " : "Concluir"} />
                        </div>

                   </>}
                   {load && <SpinnerLoad />}
                   </div>

            </form>
        </>
    )
}

interface Props {
    oldData?: Osc
    update?: boolean
    isPublic?: boolean
}
